// GENERATED by scripts/localization-sources.mjs from the governed core migration.
// Do not edit: this is a first-paint projection, never a second catalogue.
export const CORE_SHELL_MESSAGE_SOURCES = {
  "common.action.retry": "Retry",
  "common.action.sign_out": "Sign out",
  "common.state.loading": "Loading",
  "common.error.unavailable": "Unavailable",
  "navigation.expand": "Expand navigation",
  "navigation.collapse": "Collapse navigation",
  "settings.interface_language": "Interface language",
  "settings.use_default": "Use default",
  "a11y.skip_to_content": "Skip to main content",
  "localization.quality.title": "Language quality",
  "localization.quality.summary": "A live check of translated words and regional formats used by this portal.",
  "localization.quality.status": "Status",
  "localization.quality.ready": "Published and complete",
  "localization.quality.incomplete": "Translation review is not complete",
  "localization.quality.fallback": "Some optional wording is shown in English. This fallback is visible and recorded.",
  "localization.quality.date": "Date",
  "localization.quality.number": "Number",
  "localization.quality.currency": "Currency",
  "localization.quality.plural": "Plural rule",
  "localization.quality.select": "Selection rule",
  "localization.quality.refusal": "Refusal wording",
  "localization.quality.unavailable": "The language-quality check is unavailable. Try again.",
  "auth.security.title": "Sign-in and security",
  "auth.security.summary.local": "Manage how you sign in and your authenticator apps.",
  "auth.security.summary.directory": "Your organisation’s directory owns sign-in changes. You can still manage your Marble authenticator apps here.",
  "auth.security.action.close": "Close",
  "auth.security.fact.signed_in_as": "Signed in as",
  "auth.security.fact.method": "Signed in with",
  "auth.security.fact.session": "This session",
  "auth.security.method.password": "Your email and password",
  "auth.security.method.directory": "Your organisation’s directory",
  "auth.security.session.aal2": "Two-factor authentication",
  "auth.security.session.aal1": "A single factor",
  "auth.security.reset.send": "Send a password reset link",
  "auth.security.reset.sending": "Sending…",
  "auth.security.reset.sent": "If this account can receive a reset link, it is on the way to {{email}}.",
  "auth.security.reset.failed": "The reset request could not be completed. Please try again.",
  "auth.security.factors.title": "Authenticator apps",
  "auth.security.factors.summary": "These are enrolled on your account. They are separate from the assurance level of this session.",
  "auth.security.factors.loading": "Loading your authenticator apps…",
  "auth.security.factors.empty": "No authenticator app is enrolled yet.",
  "auth.security.factors.load_failed": "Your authenticator apps could not be loaded.",
  "auth.security.enroll.add": "Add authenticator app",
  "auth.security.factor.unnamed": "Authenticator app",
  "auth.security.factor.verified": "Verified",
  "auth.security.factor.unfinished": "Setup not finished",
  "auth.security.factor.remove": "Remove",
  "auth.security.factor.remove_named": "Remove {{name}}",
  "auth.security.factor.remove_title": "Remove authenticator app",
  "auth.security.factor.remove_detail": "Remove {{name}}? You will no longer be able to use it to verify your sign-in.",
  "auth.security.factor.remove_confirm": "Remove authenticator",
  "auth.security.factor.remove_cancel": "Keep authenticator",
  "auth.security.factor.remove_failed": "That authenticator could not be removed.",
  "auth.security.factor.remove_success": "Authenticator app removed.",
  "auth.security.enroll.title": "Set up an authenticator app",
  "auth.security.enroll.name": "Authenticator name",
  "auth.security.enroll.name_hint": "Use a name that helps you recognise this device or app. Maximum 100 characters.",
  "auth.security.enroll.start": "Start setup",
  "auth.security.enroll.starting": "Starting…",
  "auth.security.enroll.start_failed": "Authenticator setup could not be started.",
  "auth.security.enroll.scan": "Scan this code with your authenticator app.",
  "auth.security.enroll.qr_alt": "QR code for this authenticator setup",
  "auth.security.enroll.manual_key": "Manual setup key",
  "auth.security.enroll.code": "Six-digit code",
  "auth.security.enroll.code_hint": "Enter the current code shown by your authenticator app.",
  "auth.security.enroll.verify": "Verify and finish",
  "auth.security.enroll.verifying": "Verifying…",
  "auth.security.enroll.cancel": "Cancel setup",
  "auth.security.enroll.verify_failed": "That authenticator code was not accepted.",
  "auth.security.enroll.cleanup_failed": "Setup was closed, but the unfinished authenticator could not be removed. It remains listed below.",
  "auth.security.enroll.success": "Authenticator app added.",
  "auth.security.copy.action": "Copy",
  "auth.security.copy.success": "Copied",
  "auth.security.copy.failed": "Could not copy — select it and copy it manually",
} as const

export const CORE_SHELL_MESSAGE_REQUESTS = Object.keys(CORE_SHELL_MESSAGE_SOURCES)
  .map((key) => ({ key }))
